import classes from './founder-note.module.css';
import minPortrait from '../../assets/images/founder.png';

const FounderNote = () => {
    return (
        <section id="belief" className={classes.section} aria-labelledby="belief-title">
            <div className={classes.inner}>
                <div className={classes.slab}>
                    <div className={classes.sheen} aria-hidden="true" />

                    <p className={`eyebrow ${classes.eyebrow}`}>
                        What we changed our mind about
                    </p>

                    <h2 id="belief-title" className={classes.title}>
                        We were wrong about video.
                    </h2>

                    <div className={classes.body}>
                        <p>
                            We started PrepAnywhere believing video would revolutionize
                            learning. We built a great deal on that belief, and for years I
                            argued for it.
                        </p>

                        <p className={classes.turn}>I no longer believe it.</p>

                        <p>
                            A student watching a perfect explanation is still a student who
                            hasn't solved anything. The video was never the problem.
                            Believing it was <em>enough</em> — that was the problem.
                        </p>

                        <p>
                            What actually moves a child is cognitive activity: their own
                            pen, their own struggle, their own wrong turn and the correction
                            that comes after it. And a teacher with enough of the hour left
                            to notice it happening.
                        </p>

                        <p>
                            We still make video. We make more of it than we ever did. But it
                            earns its place only where it puts a student back to work faster
                            than they would have gotten there alone.
                        </p>

                        <p className={classes.close}>
                            Everything we build now is in service of those two things.
                        </p>
                    </div>

                    <figure className={classes.sig}>
                        <img
                            className={classes.portrait}
                            src={minPortrait}
                            alt=""
                            width="52"
                            height="52"
                            loading="lazy"
                        />
                        <figcaption>
                            <span className={classes.sigName}>Min</span>
                            <span className={classes.sigRole}>
                                Founder, PrepAnywhere
                            </span>
                        </figcaption>
                    </figure>
                </div>
            </div>
        </section>
    );
};

export default FounderNote;
